import { useEffect } from 'react'

interface UseEscListenerProps {
  shouldHandleEscape: boolean
  onEscape: () => void
}

const useEscListener = ({ shouldHandleEscape, onEscape }: UseEscListenerProps) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && shouldHandleEscape) {
        event.stopPropagation()
        onEscape()
      }
    }

    document.addEventListener('keydown', handleKeyDown, true)

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true)
    }
  }, [shouldHandleEscape, onEscape])
}

export default useEscListener
